import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Flex } from 'foundations-components/components/Flex';
import { Small } from 'foundations-components/transitional/components/Small';
import { InfoIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { hasLimit, isCapacityFull, getFullCapacityMessage } from '../../utils/capacityUtils';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TotalCapacityStatus = ({
  capacity
}) => {
  if (!isCapacityFull(capacity)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    paddingInlineStart: "200",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.agent-status.statusPopover.header.limitTickets",
        options: {
          capacityLoad: capacity.capacityLoad,
          capacityLimit: capacity.capacityLimit
        }
      }),
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "start",
          gap: "100",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: InfoIcon,
            padding: "0"
          }), getFullCapacityMessage(capacity, /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.agent-status.capacityLimits.fullCapacity"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.agent-status.capacityLimits.overCapacityInfo"
          }))]
        })
      })
    })
  });
};
TotalCapacityStatus.displayName = 'TotalCapacityStatus';
const CategoryCapacityStatus = ({
  capacity
}) => {
  const {
    CALLING,
    REAL_TIME_MESSAGING,
    ASYNC_COMMUNICATION
  } = capacity;
  let capacityMessage = null;

  // Determine which capacity type to show (messaging has priority)
  if (isCapacityFull(REAL_TIME_MESSAGING)) {
    capacityMessage = getFullCapacityMessage(REAL_TIME_MESSAGING, /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.capacityLimits.fullCapacityForMessaging"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.capacityLimits.overCapacityForMessaging"
    }));
  } else if (isCapacityFull(ASYNC_COMMUNICATION)) {
    capacityMessage = getFullCapacityMessage(ASYNC_COMMUNICATION, /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.capacityLimits.fullCapacityForAsync"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.capacityLimits.overCapacityForAsync"
    }));
  }
  if (!capacityMessage) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    paddingInlineStart: "200",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [hasLimit(CALLING) && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.header.limitCall",
          options: CALLING
        }), hasLimit(REAL_TIME_MESSAGING) && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.header.limitMessaging",
          options: REAL_TIME_MESSAGING
        }), hasLimit(ASYNC_COMMUNICATION) && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.header.limitOther",
          options: ASYNC_COMMUNICATION
        })]
      }),
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "start",
          gap: "100",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: InfoIcon,
            padding: "0"
          }), capacityMessage]
        })
      })
    })
  });
};
CategoryCapacityStatus.displayName = 'CategoryCapacityStatus';
export const CapacityStatus = ({
  userCapacity
}) => {
  const {
    type,
    capacity
  } = userCapacity;
  if (type === 'TOTAL') {
    return /*#__PURE__*/_jsx(TotalCapacityStatus, {
      capacity: capacity
    });
  } else if (type === 'BY_CAPACITY_CATEGORY') {
    return /*#__PURE__*/_jsx(CategoryCapacityStatus, {
      capacity: capacity
    });
  }
  return null;
};
CapacityStatus.displayName = 'CapacityStatus';